export const PASSWORD_MIN_LENGTH = 8;

export type PasswordPolicyCheck = {
  minLength: boolean;
  hasLetter: boolean;
  hasNumber: boolean;
  isValid: boolean;
};

export function checkPasswordPolicy(password: string): PasswordPolicyCheck {
  const p = password ?? "";
  const minLength = p.length >= PASSWORD_MIN_LENGTH;
  const hasLetter = /[A-Za-z]/.test(p);
  const hasNumber = /[0-9]/.test(p);
  const isValid = minLength && hasLetter && hasNumber;
  return { minLength, hasLetter, hasNumber, isValid };
}

export function getPasswordPolicyErrorMessage(check: PasswordPolicyCheck): string | null {
  if (!check.minLength) return `La contraseña debe tener al menos ${PASSWORD_MIN_LENGTH} caracteres`;
  if (!check.hasLetter) return "La contraseña debe contener al menos una letra";
  if (!check.hasNumber) return "La contraseña debe contener al menos un número";
  return null;
}

